module.exports = __webpack_public_path__ + "static/home_mobile-5f788ac6c0724ca710b1f58a152d9859.jpg";